import { customHtml } from '@yola/ws-sdk';
import bowser from 'yola-bowser';

const { constants, operations } = customHtml;

const {
  renderStatuses: { WEB_SITE_ONLY },
} = constants;

export const detectSafeMode = () => {
  const params = new URLSearchParams(window.location.search);
  const scriptsParam = params.get('safeMode');
  const isSafeModeDetected = scriptsParam === '1';
  const isTouchDevice = bowser.mobile || bowser.tablet;

  if (isSafeModeDetected || isTouchDevice) {
    operations.setRenderStatus(WEB_SITE_ONLY);
  }
};
